import React from 'react';

type ConnectorsOverviewCardComponentProps = {
  isActive: boolean;
  connector: string;
  isDisconnected?: boolean;
};

export default class ConnectorsOverviewCardComponent extends React.Component<
  ConnectorsOverviewCardComponentProps,
  {}
> {
  render() {
    const { connector, isDisconnected } = this.props;

    return (
      <div
        className={` d-flex ${
          isDisconnected ? 'flex-column' : ''
        } card-body py-auto justify-content-center align-self-center align-items-center con-map-mk-card-size`}
      >
        <img
          src={`/media/integrations/logos/${connector}.svg`}
          className="w-50"
        />
        {isDisconnected && (
          <span className="badge badge-warning mt-2">Disconnected</span>
        )}
      </div>
    );
  }
}
